"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var element_1 = require("@formily/element");
// 直接导出原始 ArrayTable
var NewArrayTable = element_1.ArrayTable;
exports.default = NewArrayTable;
